import axios from 'axios';
import config from "./config"
import Store from '@/store'
import Router from '../router'
import Vue from 'vue'; // 引入vue

class RequestSender {
    static headers = {
        'Accept': 'application/json',
        //'Content-Type': 'multipart/form-data'
        'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'
    };


    static _getData(data) {
        let datas = new FormData();
        for (var i in data) {
            datas.append(i, data[i]);
        }
        datas.append("token", Store.state.user?Store.state.user.token:"");
        datas.append("project_id", Store.state.config?Store.state.config.project_id:"");
        return datas;
    }

    static _getUrl(url) {
        return config.baseUrl + url;
    }

    static post(url, data, timeout = 15000) {
        
       
        return this._getRequest({
            method: 'post',
            url: this._getUrl(url),
            baseURL: '',
            headers: this.headers,
            data: this._getData(data),
            timeout: timeout,
        });
    }
    static get(url, data, timeout = 15000) {
        
     
        return this._getRequest({
            method: 'get',
            url: this._getUrl(url),
            baseURL: '',
            headers: this.headers,
            data: this._getData(data),
            timeout: timeout,
        });
    }

    static _getRequest(config) {
        return new Promise((resolve, reject) => {
            (new Vue()).$loading.show()
            axios(config)
                .then(res => { 
                    (new Vue()).$loading.hide()
                    if (res.data.status == "403") {
                        Router.push({ path:"/" });
                    } else {
                        resolve(res.data);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

}
export default RequestSender;


